import React, { useState } from 'react';

import styled, { css } from 'styled-components';

import ReactPlayer from 'react-player/youtube';



const PlayButton = () => {
  return (
    <StyledPlayButton>
      Watch Video
    </StyledPlayButton>
  )
};

const VideoEmbed = ({ block, className }) => {

  const [playing, setPlaying] = useState(false);

  return (
    <Container className={className} >
      <ReactPlayer
        className={'video-player'} 
        url={block.videoUrl} 
        width="100%"
        height="100%"
        playing={playing}
        light={true}
        playIcon={<PlayButton />}
        playing={true}
        config={{
          youtube: {
            playerVars: {
              autoplay: 1,
              modestbranding: 1,
            }
          }
        }}
      />
    </Container>
  )
};


export default VideoEmbed;

const Container = styled.section`
  display: flex;
  justify-content: center;
  margin: 2em 0;
  width: 100%;
  max-width: ${({ theme }) => theme.content.CONTENT_WIDTH};
  padding-top: 56.25%;
  position: relative;

  @media all and (min-width: 850px) {
    padding-top: 478px;
  }

  .video-player {
    position: absolute;
    top: 0px;
    left: 0px;
  }
`;

const StyledPlayButton = styled.button`
  color: white;
  font-size: 2.4em;
  border: 2px solid white;
  background-color: transparent;
  padding: 0.15em 1em;
  font-family: 'Bebas Neue', serif;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.colors.Primary};
    background-color: white;
  }
`;



